import { useAppState, useAppDispatch } from './Context'

function LocationZip() {
  const dispatch = useAppDispatch()
  const { endpoint, map, maps } = useAppState()

  const handleSubmit = (e) => {
    e.preventDefault()

    const zip = new FormData(e.target).get('zip')

    ajax
      .url(`${endpoint}searchzip`)
      .query({ zip })
      .get()
      .json((res) => {
        if (res.success) {
          dispatch({ type: 'setSelectedLocation', payload: null })
          dispatch({ type: 'setLocations', payload: res.locations })
          dispatch({ type: 'setUserCoords', payload: res.userCoords })
          map.panTo(new maps.LatLng(res.userCoords.lat, res.userCoords.lng))
          map.setZoom(8)
        }
      })
  }

  return (
    <form className="flex relative" onSubmit={handleSubmit}>
      <input
        type="text"
        name="zip"
        placeholder="Enter Zip"
        className="py-3 px-4 w-full text-base rounded-md rounded-r-none border border-r-0 border-olive"
      />
      <button type="submit" className="flex-shrink-0 px-4 w-20 text-sm font-semibold rounded-r btn-fill">
        Find
      </button>
    </form>
  )
}

export default LocationZip
